'use client'
import type { FC } from 'react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import Link from 'next/link'
import { format, parseISO } from 'date-fns'
import cn from 'classnames'
import { useParams } from 'next/navigation'
import s from './style.module.css'
import { allPosts } from '@/.contentlayer/generated'

const Main: FC = () => {
  const { t } = useTranslation()
  const params = useParams()
  const lang = params.lang as string
  const _allPosts = allPosts.filter((post) => {
    return lang === post._raw.flattenedPath.split('.')[1]
  })

  return (
    <div className={cn('mt-5', 'mx-auto max-w-7xl px-2 sm:px-6 lg:px-8')}>
      <h1 className='text-3xl font-medium'>The latest Babel news</h1>
      <div className={cn(s.posts)}>
        {_allPosts.map(post => (
          <article key={post._id} className={s.article}>
            <div className='p-3'>
              <time dateTime={post.date} className="text-sm text-gray-400">
                {format(parseISO(post.date), 'yyyy.L.d')}
              </time>
              <h2 className='text-xl leading-8 m-0 font-medium mb-1'>{post.title}</h2>
              {post.description && <p className='text-[15px] text-neutral-600'>{post.description}</p>}
            </div>
            <Link href={`/${lang}${post.url}`} className={s.more}>Read More</Link>
          </article>
        ))}
      </div>
    </div>
  )
}
export const runtime = 'edge'
export default React.memo(Main)
